<template>
  <div class="toaster" v-if="status">
    <div id="snackbar" :style="{ background: color }">
      <span class="close_button">
        <i class="material-icons" @click="status=false">close</i>
      </span>
      <p>{{msg}}</p>
    </div>
  </div>
</template>
<script>
import constant from "../../utils/constant";
export default {
  name: "CustomToaster",
  props: {
    dataValue: {
      type: Object
    }
  },
  data() {
    return {
      msg: "",
      status: false,
      color: "black"
    };
  },
  watch: {
    dataValue() {
      if (this.dataValue) {
        this.status = true;
        this.msg = this.dataValue.msg;
        this.color = this.dataValue.color;
        setTimeout(
          () => {
            this.status = false;
          },
          this.dataValue.timeoutMs ? this.dataValue.timeoutMs : 2000
        );
      }
    }
  },
  mounted() {
    if (this.dataValue) {
      this.status = true;
      this.msg = this.dataValue.msg;
      this.color = this.dataValue.color;
      setTimeout(
        () => {
          this.status = false;
        },
        this.dataValue.timeoutMs ? this.dataValue.timeoutMs : 5000
      );
    }
  }
};
</script>
<style scoped>
#snackbar {
  width: 80%;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 10px;
  position: fixed;
  z-index: 99;
  left: 50%;
  bottom: 60px;
  font-size: 0.875em;
  padding-right: 30px;
  transform: translateX(-50%);
}
#snackbar .close_button {
  top: 5px;
  right: 5px;
  background: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
}
#snackbar .close_button i {
  color: #000;
  font-size: 0.875em;
  line-height: 1.8;
  font-weight: 600;
}
#snackbar.show {
  visibility: visible;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

@-webkit-keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}
</style>